/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
import { ActionType, deprecated } from "typesafe-actions";
const { createStandardAction } = deprecated;
import { FilterKeys } from "@/store/state";

const addFilter = createStandardAction("[filter] add filter")<{
  key: FilterKeys;
  value: string;
}>();

const addSingleFilter = createStandardAction("[filter] add single filter")<{
  key: FilterKeys;
  value: string;
}>();

const removeFilter = createStandardAction("[filter] remove filter")<{
  key: FilterKeys;
  value?: string;
}>();

const addFilterAll = createStandardAction("[filter] add filter all")<{
  key: FilterKeys;
  value: string[];
}>();

const removeFilterAll = createStandardAction("[filter] remove filter all")<{
  key: FilterKeys;
}>();

// Adds several values to a filter key's existing selection in a single dispatch
const addFilterMany = createStandardAction("[filter] add filter many")<{
  key: FilterKeys;
  values: string[];
}>();

// Removes several values from a filter key's existing selection in a single dispatch
const removeFilterMany = createStandardAction("[filter] remove filter many")<{
  key: FilterKeys;
  values: string[];
}>();

const clear = createStandardAction("[filter] clear")<FilterKeys[]>();

// empties it
const clearDraft = createStandardAction("[filter] clear draft")<FilterKeys>();

// resets the whole draft to equal active
const resetDraft = createStandardAction("[filter] reset draft")<void>();

const applyDraft = createStandardAction("[filter] apply draft")<FilterKeys>();

const searchDraft = createStandardAction("[filter] search draft")<{
  value: string;
}>();

export const actions = {
  addFilter,
  addSingleFilter,
  removeFilter,
  clearDraft,
  resetDraft,
  clear,
  applyDraft,
  searchDraft,
  addFilterAll,
  removeFilterAll,
  addFilterMany,
  removeFilterMany,
};

export type Actions = ActionType<typeof actions>;
